import contractorSiteDeliveryCard from '@assets/documents/pdc/contractorSiteDeliveryCard.webp'
import detailsOfOverheadLines from '@assets/documents/pdc/detailsOfOverheadLines.webp'
import excavationAndCableLayingWork from '@assets/documents/pdc/excavationAndCableLayingWork.webp'
import listOHInspection from '@assets/documents/pdc/listOHInspection.webp'
import lvMeterInstallation from '@assets/documents/pdc/lvMeterInstallation.webp'
import measurementsSheetForMeters from '@assets/documents/pdc/measurementsSheetForMeters.webp'
import measurementsSheetForOHNetwork from '@assets/documents/pdc/measurementsSheetForOHNetwork.webp'
import minipillar from '@assets/documents/pdc/minipillar.webp'
import mvMeterInstallation from '@assets/documents/pdc/mvMeterInstallation.webp'
import overheadLineAsBuiltReportSummary from '@assets/documents/pdc/overheadLineAsBuiltReportSummary.webp'
import procedure190 from '@assets/documents/pdc/procedure190.webp'
import siteInfractionForm from '@assets/documents/pdc/siteInfractionForm.webp'
import splicingTermination from '@assets/documents/pdc/splicingTermination.webp'
import substationAndElectricalEquipmentInspection from '@assets/documents/pdc/substationAndElectricalEquipmentInspection.webp'
import substationEarthing from '@assets/documents/pdc/substationEarthing.webp'
import substationFoundation from '@assets/documents/pdc/substationFoundation.webp'
import workSiteInspectionForm from '@assets/documents/pdc/workSiteInspectionForm.webp'
import recordOfFacts from '@assets/documents/pdc/recordOfFacts.webp'
import measurementSheet from '@assets/documents/pdc/measurementSheet.webp'

export const pdc = props => [
    {
        text: 'بطاقة تسليم الموقع للمقاول',
        image: contractorSiteDeliveryCard,
        fields: [
            {type: 't', x: 918, y: 260, w: 112, h: 26, default: props.dep, align: 'center'},
            {type: 't', x: 210, y: 260, w: 244, h: 26, default: props.div, align: 'center'},
            {type: 't', x: 871, y: 317, w: 153, h: 86, default: props.district},
            {type: 't', x: 598, y: 317, w: 153, h: 86, default: props.feeder},
            {type: 't', x: 152, y: 317, w: 299, h: 86, default: props.contractor},
            {type: 't', x: 597, y: 406, w: 264, h: 68},
            {type: 't', x: 151, y: 406, w: 276, h: 68, default: props.now_date},
            {type: 't', x: 597, y: 479, w: 264, h: 68},
            {type: 't', x: 152, y: 479, w: 261, h: 68, default: props.number},
            {type: 't', x: 913, y: 658, w: 224, h: 46},
            {type: 't', x: 352, y: 658, w: 560, h: 46, default: 'لايوجد'},
            {type: 't', x: 247, y: 658, w: 103, h: 46, default: props.now_time},
            {type: 't', x: 151, y: 658, w: 94, h: 46, default: props.now_date},
            {type: 't', x: 913, y: 707, w: 224, h: 46},
            {type: 't', x: 352, y: 707, w: 560, h: 46},
            {type: 't', x: 247, y: 707, w: 103, h: 46},
            {type: 't', x: 151, y: 707, w: 94, h: 46},
            {type: 't', x: 913, y: 758, w: 224, h: 46},
            {type: 't', x: 352, y: 758, w: 560, h: 46},
            {type: 't', x: 247, y: 758, w: 103, h: 46},
            {type: 't', x: 151, y: 758, w: 94, h: 46},
            {type: 't', x: 913, y: 809, w: 224, h: 46},
            {type: 't', x: 352, y: 809, w: 560, h: 46},
            {type: 't', x: 247, y: 809, w: 103, h: 46},
            {type: 't', x: 151, y: 809, w: 94, h: 46},
            {type: 't', x: 913, y: 859, w: 224, h: 46},
            {type: 't', x: 352, y: 859, w: 560, h: 46},
            {type: 't', x: 247, y: 859, w: 103, h: 46},
            {type: 't', x: 151, y: 859, w: 94, h: 46},
            {type: 't', x: 913, y: 909, w: 224, h: 46},
            {type: 't', x: 352, y: 909, w: 560, h: 46},
            {type: 't', x: 247, y: 909, w: 103, h: 46},
            {type: 't', x: 151, y: 909, w: 94, h: 46},
            {type: 't', x: 913, y: 960, w: 224, h: 46},
            {type: 't', x: 352, y: 960, w: 560, h: 46},
            {type: 't', x: 247, y: 960, w: 103, h: 46},
            {type: 't', x: 151, y: 960, w: 94, h: 46},
            {type: 't', x: 680, y: 1125, w: 375, h: 30, default: props.supervisor.name, readonly: true, align: 'center'},
            {type: 'i', x: 270, y: 1125, w: 200, h: 52, default: props.supervisor.signature, readonly: true},
            {type: 't', x: 680, y: 1205, w: 375, h: 30, default: props.user.name, readonly: true, align: 'center'},
            {type: 'i', x: 270, y: 1205, w: 200, h: 52, default: props.user.signature, readonly: true},
            {type: 't', x: 680, y: 1290, w: 375, h: 30, default: props.delegate.name, readonly: true, align: 'center'},
            {type: 'i', x: 270, y: 1280, w: 200, h: 52, default: props.delegate.signature, readonly: true},
        ]
    },
    {
        text: 'نموذج التفتيش على موقع العمل',
        image: workSiteInspectionForm,
        fields: [
            {type: 't', x: 700, y: 148, w: 293, h: 30, default: props.div},
            {type: 't', x: 65, y: 148, w: 454, h: 30, default: props.number},
            {type: 't', x: 700, y: 181, w: 293, h: 30, default: props.user.name, readonly: true},
            {type: 't', x: 65, y: 181, w: 454, h: 30},
            {type: 't', x: 700, y: 214, w: 293, h: 30, default: props.now_date},
            {type: 't', x: 65, y: 214, w: 454, h: 30, default: props.now_time},
            {type: 't', x: 65, y: 248, w: 927, h: 30, default: props.notes},
            {type: 't', x: 65, y: 282, w: 927, h: 30, default: props.contractor},
            {type: 'y', x: 496, y: 384, w: 69, h: 26, group: 'g384', default: 'yes'},
            {type: 'y', x: 424, y: 384, w: 69, h: 26, group: 'g384'},
            {type: 'y', x: 353, y: 384, w: 69, h: 26, group: 'g384'},
            {type: 't', x: 68, y: 384, w: 281, h: 26},
            {type: 'y', x: 496, y: 427, w: 69, h: 26, group: 'g427', default: 'yes'},
            {type: 'y', x: 424, y: 427, w: 69, h: 26, group: 'g427'},
            {type: 'y', x: 353, y: 427, w: 69, h: 26, group: 'g427'},
            {type: 't', x: 68, y: 427, w: 281, h: 26},
            {type: 'y', x: 496, y: 469, w: 69, h: 26, group: 'g469', default: 'yes'},
            {type: 'y', x: 424, y: 469, w: 69, h: 26, group: 'g469'},
            {type: 'y', x: 353, y: 469, w: 69, h: 26, group: 'g469'},
            {type: 't', x: 68, y: 469, w: 281, h: 26},
            {type: 'y', x: 496, y: 510, w: 69, h: 26, group: 'g510', default: 'yes'},
            {type: 'y', x: 424, y: 510, w: 69, h: 26, group: 'g510'},
            {type: 'y', x: 353, y: 510, w: 69, h: 26, group: 'g510'},
            {type: 't', x: 68, y: 510, w: 281, h: 26},
            {type: 'y', x: 496, y: 552, w: 69, h: 26, group: 'g552', default: 'yes'},
            {type: 'y', x: 424, y: 552, w: 69, h: 26, group: 'g552'},
            {type: 'y', x: 353, y: 552, w: 69, h: 26, group: 'g552'},
            {type: 't', x: 68, y: 552, w: 281, h: 26},
            {type: 'y', x: 496, y: 593, w: 69, h: 26, group: 'g593', default: 'yes'},
            {type: 'y', x: 424, y: 593, w: 69, h: 26, group: 'g593'},
            {type: 'y', x: 353, y: 593, w: 69, h: 26, group: 'g593'},
            {type: 't', x: 68, y: 593, w: 281, h: 26},
            {type: 'y', x: 496, y: 633, w: 69, h: 26, group: 'g633', default: 'yes'},
            {type: 'y', x: 424, y: 633, w: 69, h: 26, group: 'g633'},
            {type: 'y', x: 353, y: 633, w: 69, h: 26, group: 'g633'},
            {type: 't', x: 68, y: 633, w: 281, h: 26},
            {type: 'y', x: 496, y: 675, w: 69, h: 26, group: 'g675', default: 'yes'},
            {type: 'y', x: 424, y: 675, w: 69, h: 26, group: 'g675'},
            {type: 'y', x: 353, y: 675, w: 69, h: 26, group: 'g675'},
            {type: 't', x: 68, y: 675, w: 281, h: 26},
            {type: 'y', x: 496, y: 717, w: 69, h: 26, group: 'g717', default: 'yes'},
            {type: 'y', x: 424, y: 717, w: 69, h: 26, group: 'g717'},
            {type: 'y', x: 353, y: 717, w: 69, h: 26, group: 'g717'},
            {type: 't', x: 68, y: 717, w: 281, h: 26},
            {type: 'y', x: 496, y: 752, w: 69, h: 26, group: 'g752'},
            {type: 'y', x: 424, y: 752, w: 69, h: 26, group: 'g752'},
            {type: 'y', x: 353, y: 752, w: 69, h: 26, group: 'g752', default: 'yes'},
            {type: 't', x: 68, y: 752, w: 281, h: 26},
            {type: 'y', x: 496, y: 780, w: 69, h: 26, group: 'g780', default: 'yes'},
            {type: 'y', x: 424, y: 780, w: 69, h: 26, group: 'g780'},
            {type: 'y', x: 353, y: 780, w: 69, h: 26, group: 'g780'},
            {type: 't', x: 68, y: 780, w: 281, h: 26},
            {type: 'y', x: 496, y: 815, w: 69, h: 26, group: 'g815'},
            {type: 'y', x: 424, y: 815, w: 69, h: 26, group: 'g815'},
            {type: 'y', x: 353, y: 815, w: 69, h: 26, group: 'g815', default: 'yes'},
            {type: 't', x: 68, y: 815, w: 281, h: 26},
            {type: 'y', x: 496, y: 857, w: 69, h: 26, group: 'g857', default: 'yes'},
            {type: 'y', x: 424, y: 857, w: 69, h: 26, group: 'g857'},
            {type: 'y', x: 353, y: 857, w: 69, h: 26, group: 'g857'},
            {type: 't', x: 68, y: 857, w: 281, h: 26},
            {type: 'y', x: 496, y: 900, w: 69, h: 26, group: 'g900', default: 'yes'},
            {type: 'y', x: 424, y: 900, w: 69, h: 26, group: 'g900'},
            {type: 'y', x: 353, y: 900, w: 69, h: 26, group: 'g900'},
            {type: 't', x: 68, y: 900, w: 281, h: 26},
            {type: 'y', x: 496, y: 941, w: 69, h: 26, group: 'g941', default: 'yes'},
            {type: 'y', x: 424, y: 941, w: 69, h: 26, group: 'g941'},
            {type: 'y', x: 353, y: 941, w: 69, h: 26, group: 'g941'},
            {type: 't', x: 68, y: 941, w: 281, h: 26},
            {type: 'y', x: 496, y: 981, w: 69, h: 26, group: 'g981', default: 'yes'},
            {type: 'y', x: 424, y: 981, w: 69, h: 26, group: 'g981'},
            {type: 'y', x: 353, y: 981, w: 69, h: 26, group: 'g981'},
            {type: 't', x: 68, y: 981, w: 281, h: 26},
            {type: 'y', x: 496, y: 1022, w: 69, h: 26, group: 'g1022', default: 'yes'},
            {type: 'y', x: 424, y: 1022, w: 69, h: 26, group: 'g1022'},
            {type: 'y', x: 353, y: 1022, w: 69, h: 26, group: 'g1022'},
            {type: 't', x: 68, y: 1022, w: 281, h: 26},
            {type: 'y', x: 496, y: 1055, w: 69, h: 26, group: 'g1055', default: 'yes'},
            {type: 'y', x: 424, y: 1055, w: 69, h: 26, group: 'g1055'},
            {type: 'y', x: 353, y: 1055, w: 69, h: 26, group: 'g1055'},
            {type: 't', x: 68, y: 1055, w: 281, h: 26},
            {type: 'y', x: 496, y: 1090, w: 69, h: 26, group: 'g1090', default: 'yes'},
            {type: 'y', x: 424, y: 1090, w: 69, h: 26, group: 'g1090'},
            {type: 'y', x: 353, y: 1090, w: 69, h: 26, group: 'g1090'},
            {type: 't', x: 68, y: 1090, w: 281, h: 26},
            {type: 'y', x: 496, y: 1125, w: 69, h: 26, group: 'g1125', default: 'yes'},
            {type: 'y', x: 424, y: 1125, w: 69, h: 26, group: 'g1125'},
            {type: 'y', x: 353, y: 1125, w: 69, h: 26, group: 'g1125'},
            {type: 't', x: 68, y: 1125, w: 281, h: 26},
            {type: 'y', x: 496, y: 1154, w: 69, h: 26, group: 'g1154', default: 'yes'},
            {type: 'y', x: 424, y: 1154, w: 69, h: 26, group: 'g1154'},
            {type: 'y', x: 353, y: 1154, w: 69, h: 26, group: 'g1154'},
            {type: 't', x: 68, y: 1154, w: 281, h: 26},
            {type: 'y', x: 496, y: 1184, w: 69, h: 26, group: 'g1184', default: 'yes'},
            {type: 'y', x: 424, y: 1184, w: 69, h: 26, group: 'g1184'},
            {type: 'y', x: 353, y: 1184, w: 69, h: 26, group: 'g1184'},
            {type: 't', x: 68, y: 1184, w: 281, h: 26},
            {type: 'y', x: 496, y: 1216, w: 69, h: 26, group: 'g1216', default: 'yes'},
            {type: 'y', x: 424, y: 1216, w: 69, h: 26, group: 'g1216'},
            {type: 'y', x: 353, y: 1216, w: 69, h: 26, group: 'g1216'},
            {type: 't', x: 68, y: 1216, w: 281, h: 26},
            {type: 'y', x: 496, y: 1249, w: 69, h: 26, group: 'g1249', default: 'yes'},
            {type: 'y', x: 424, y: 1249, w: 69, h: 26, group: 'g1249'},
            {type: 'y', x: 353, y: 1249, w: 69, h: 26, group: 'g1249'},
            {type: 't', x: 68, y: 1249, w: 281, h: 26},
            {type: 'y', x: 496, y: 1284, w: 69, h: 26, group: 'g1284'},
            {type: 'y', x: 424, y: 1284, w: 69, h: 26, group: 'g1284', default: 'yes'},
            {type: 'y', x: 353, y: 1284, w: 69, h: 26, group: 'g1284'},
            {type: 't', x: 68, y: 1284, w: 281, h: 26},
            {type: 'y', x: 496, y: 1325, w: 69, h: 26, group: 'g1325'},
            {type: 'y', x: 424, y: 1325, w: 69, h: 26, group: 'g1325'},
            {type: 'y', x: 353, y: 1325, w: 69, h: 26, group: 'g1325', default: 'yes'},
            {type: 't', x: 68, y: 1325, w: 281, h: 26},
            {type: 't', x: 569, y: 1368, w: 461, h: 24, default: props.user.name},
            {type: 'i', x: 166, y: 1353, w: 200, h: 52, default: props.user.signature},
            {type: 't', x: 569, y: 1409, w: 452, h: 24, default: props.delegate.name},
            {type: 'i', x: 166, y: 1396, w: 200, h: 52, default: props.delegate.signature},
        ]
    },
    {
        text: 'أعمال الحفر وتمديدات الكوابل',
        image: excavationAndCableLayingWork,
        fields: [
            {type: 't', x: 969, y: 231, w: 115, h: 20, default: props.dep, align: 'center'},
            {type: 't', x: 145, y: 231, w: 229, h: 20, default: props.div, align: 'center'},
            {type: 't', x: 803, y: 273, w: 315, h: 20, default: props.district, align: 'center'},
            {type: 't', x: 183, y: 273, w: 340, h: 20, default: props.feeder, align: 'center'},
            {type: 't', x: 804, y: 301, w: 315, h: 20, default: props.contractor, align: 'center'},
            {type: 't', x: 223, y: 301, w: 285, h: 20, default: props.number, align: 'center'},
            {type: 'yn', x: 561, y: 369, w: 77, h: 20, default: 'yes'},
            {type: 'yn', x: 561, y: 406, w: 77, h: 20, default: 'yes'},
            {type: 'yn', x: 561, y: 450, w: 77, h: 20, default: 'yes'},
            {type: 'yn', x: 561, y: 493, w: 77, h: 20, default: 'yes'},
            {type: 'yn', x: 561, y: 525, w: 77, h: 20, default: 'yes'},
            {type: 'yn', x: 561, y: 559, w: 77, h: 20, default: 'yes'},
            {type: 'yn', x: 561, y: 591, w: 77, h: 20, default: 'yes'},
            {type: 'yn', x: 561, y: 624, w: 77, h: 20},
            {type: 'yn', x: 561, y: 656, w: 77, h: 20},
            {type: 'yn', x: 561, y: 691, w: 77, h: 20},
            {type: 'yn', x: 561, y: 722, w: 77, h: 20},
            {type: 'yn', x: 561, y: 755, w: 77, h: 20},
            {type: 'yn', x: 561, y: 799, w: 77, h: 20},
            {type: 'yn', x: 561, y: 831, w: 77, h: 20},
            {type: 'yn', x: 561, y: 864, w: 77, h: 20},
            {type: 'yn', x: 561, y: 896, w: 77, h: 20},
            {type: 'yn', x: 561, y: 929, w: 77, h: 20},
            {type: 'yn', x: 561, y: 973, w: 77, h: 20},
            {type: 'yn', x: 561, y: 1016, w: 77, h: 20},
            {type: 'yn', x: 561, y: 1048, w: 77, h: 20},
            {type: 'yn', x: 561, y: 1070, w: 77, h: 20},
            {type: 'yn', x: 561, y: 1092, w: 77, h: 20},
            {type: 'yn', x: 561, y: 1115, w: 77, h: 20},
            {type: 'yn', x: 561, y: 1148, w: 77, h: 20},
            {type: 'yn', x: 561, y: 1183, w: 77, h: 20},
            {type: 't', x: 83, y: 1215, w: 910, h: 20},
            {type: 't', x: 662, y: 1261, w: 394, h: 20, readonly: true, default: props.user.name},
            {type: 'i', x: 866, y: 1296, w: 250, h: 65, readonly: true, default: props.user.signature},
            {type: 't', x: 80, y: 1261, w: 221, h: 20, readonly: true, default: props.delegate.name},
            {type: 'i', x: 350, y: 1296, w: 250, h: 65, readonly: true, default: props.delegate.signature},
        ]
    },
    {
        text: 'وصلات لحام / وصلات نهاية',
        image: splicingTermination,
        fields: [
            {type: 't', x: 694, y: 187, w: 323, h: 20, default: props.dep},
            {type: 't', x: 104, y: 187, w: 487, h: 20, default: props.div},
            {type: 't', x: 694, y: 212, w: 323, h: 20},
            {type: 't', x: 104, y: 212, w: 524, h: 20, default: props.contractor},
            {type: 'y', x: 693, y: 355, w: 71, h: 23, group: 'g355'},
            {type: 'y', x: 622, y: 355, w: 71, h: 23, group: 'g355'},
            {type: 'y', x: 693, y: 380, w: 71, h: 23, group: 'g380'},
            {type: 'y', x: 622, y: 380, w: 71, h: 23, group: 'g380'},
            {type: 'y', x: 693, y: 405, w: 71, h: 23, group: 'g405'},
            {type: 'y', x: 622, y: 405, w: 71, h: 23, group: 'g405'},
            {type: 'y', x: 693, y: 429, w: 71, h: 23, group: 'g429'},
            {type: 'y', x: 622, y: 429, w: 71, h: 23, group: 'g429'},
            {type: 'y', x: 693, y: 453, w: 71, h: 23, group: 'g453'},
            {type: 'y', x: 622, y: 453, w: 71, h: 23, group: 'g453'},
            {type: 'y', x: 693, y: 478, w: 71, h: 23, group: 'g478'},
            {type: 'y', x: 622, y: 478, w: 71, h: 23, group: 'g478'},
            {type: 'y', x: 693, y: 503, w: 71, h: 23, group: 'g503'},
            {type: 'y', x: 622, y: 503, w: 71, h: 23, group: 'g503'},
            {type: 'y', x: 693, y: 527, w: 71, h: 23, group: 'g527'},
            {type: 'y', x: 622, y: 527, w: 71, h: 23, group: 'g527'},
            {type: 'y', x: 693, y: 551, w: 71, h: 23, group: 'g551'},
            {type: 'y', x: 622, y: 551, w: 71, h: 23, group: 'g551'},
            {type: 'y', x: 693, y: 588, w: 71, h: 23, group: 'g588'},
            {type: 'y', x: 622, y: 588, w: 71, h: 23, group: 'g588'},
            {type: 'y', x: 693, y: 624, w: 71, h: 23, group: 'g624'},
            {type: 'y', x: 622, y: 624, w: 71, h: 23, group: 'g624'},
            {type: 'y', x: 693, y: 649, w: 71, h: 23, group: 'g649'},
            {type: 'y', x: 622, y: 649, w: 71, h: 23, group: 'g649'},
            {type: 'y', x: 693, y: 673, w: 71, h: 23, group: 'g673'},
            {type: 'y', x: 622, y: 673, w: 71, h: 23, group: 'g673'},
            {type: 'y', x: 693, y: 698, w: 71, h: 23, group: 'g698'},
            {type: 'y', x: 622, y: 698, w: 71, h: 23, group: 'g698'},
            {type: 'y', x: 693, y: 770, w: 71, h: 23, group: 'g770'},
            {type: 'y', x: 622, y: 770, w: 71, h: 23, group: 'g770', default: 'yes'},
            {type: 'y', x: 693, y: 806, w: 71, h: 23, group: 'g806'},
            {type: 'y', x: 622, y: 806, w: 71, h: 23, group: 'g806', default: 'yes'},
            {type: 'y', x: 693, y: 843, w: 71, h: 23, group: 'g843'},
            {type: 'y', x: 622, y: 843, w: 71, h: 23, group: 'g843', default: 'yes'},
            {type: 'y', x: 693, y: 868, w: 71, h: 23, group: 'g868'},
            {type: 'y', x: 622, y: 868, w: 71, h: 23, group: 'g868', default: 'yes'},
            {type: 'y', x: 693, y: 891, w: 71, h: 23, group: 'g891'},
            {type: 'y', x: 622, y: 891, w: 71, h: 23, group: 'g891', default: 'yes'},
            {type: 'y', x: 693, y: 916, w: 71, h: 23, group: 'g916'},
            {type: 'y', x: 622, y: 916, w: 71, h: 23, group: 'g916', default: 'yes'},
            {type: 'y', x: 693, y: 941, w: 71, h: 23, group: 'g941'},
            {type: 'y', x: 622, y: 941, w: 71, h: 23, group: 'g941', default: 'yes'},
            {type: 'y', x: 693, y: 965, w: 71, h: 23, group: 'g965'},
            {type: 'y', x: 622, y: 965, w: 71, h: 23, group: 'g965', default: 'yes'},
            {type: 'y', x: 693, y: 990, w: 71, h: 23, group: 'g990'},
            {type: 'y', x: 622, y: 990, w: 71, h: 23, group: 'g990', default: 'yes'},
            {type: 'y', x: 693, y: 1014, w: 71, h: 23, group: 'g1014'},
            {type: 'y', x: 622, y: 1014, w: 71, h: 23, group: 'g1014', default: 'yes'},
            {type: 'y', x: 693, y: 1040, w: 71, h: 23, group: 'g1040'},
            {type: 'y', x: 622, y: 1040, w: 71, h: 23, group: 'g1040', default: 'yes'},
            {type: 'y', x: 693, y: 1064, w: 71, h: 23, group: 'g1064'},
            {type: 'y', x: 622, y: 1064, w: 71, h: 23, group: 'g1064', default: 'yes'},
            {type: 'y', x: 693, y: 1088, w: 71, h: 23, group: 'g1088'},
            {type: 'y', x: 622, y: 1088, w: 71, h: 23, group: 'g1088', default: 'yes'},
            {type: 't', x: 108, y: 1144, w: 1087, h: 23, align: 'center'},
            {type: 't', x: 108, y: 1207, w: 978, h: 23, default: props.user.name, readonly: true},
            {type: 'i', x: 936, y: 1231, w: 200, h: 52, default: props.user.signature, readonly: true},
            {type: 't', x: 108, y: 1291, w: 736, h: 22, default: props.delegate.name, readonly: true},
            {type: 'i', x: 936, y: 1323, w: 200, h: 52, default: props.delegate.signature, readonly: true},
        ]
    },
    {
        text: 'لوحة التوزيع',
        image: minipillar,
        fields: [
            {type: 't', x: 791, y: 254, w: 287, h: 30, default: props.dep, align: 'center'},
            {type: 't', x: 199, y: 254, w: 414, h: 30, default: props.div, align: 'center'},
            {type: 't', x: 838, y: 293, w: 233, h: 30, default: props.number, align: 'center'},
            {type: 't', x: 256, y: 293, w: 361, h: 30, default: props.district, align: 'center'},
            {type: 't', x: 854, y: 335, w: 233, h: 30, default: props.feeder, align: 'center'},
            {type: 't', x: 269, y: 335, w: 342, h: 30, default: props.contractor, align: 'center'},
            {type: 'y', x: 682, y: 423, w: 66, h: 37, group: 'g423'},
            {type: 'y', x: 612, y: 423, w: 66, h: 37, group: 'g423', default: 'yes'},
            {type: 'y', x: 682, y: 511, w: 66, h: 37, group: 'g511'},
            {type: 'y', x: 612, y: 511, w: 66, h: 37, group: 'g511', default: 'yes'},
            {type: 'y', x: 682, y: 556, w: 66, h: 37, group: 'g556'},
            {type: 'y', x: 612, y: 556, w: 66, h: 37, group: 'g556', default: 'yes'},
            {type: 'y', x: 682, y: 597, w: 66, h: 37, group: 'g597'},
            {type: 'y', x: 612, y: 597, w: 66, h: 37, group: 'g597', default: 'yes'},
            {type: 'y', x: 682, y: 640, w: 66, h: 37, group: 'g640'},
            {type: 'y', x: 612, y: 640, w: 66, h: 37, group: 'g640', default: 'yes'},
            {type: 'y', x: 682, y: 685, w: 66, h: 37, group: 'g685'},
            {type: 'y', x: 612, y: 685, w: 66, h: 37, group: 'g685', default: 'yes'},
            {type: 'y', x: 682, y: 726, w: 66, h: 37, group: 'g726'},
            {type: 'y', x: 612, y: 726, w: 66, h: 37, group: 'g726', default: 'yes'},
            {type: 'y', x: 682, y: 770, w: 66, h: 37, group: 'g770'},
            {type: 'y', x: 612, y: 770, w: 66, h: 37, group: 'g770', default: 'yes'},
            {type: 'y', x: 682, y: 815, w: 66, h: 37, group: 'g815'},
            {type: 'y', x: 612, y: 815, w: 66, h: 37, group: 'g815', default: 'yes'},
            {type: 'y', x: 682, y: 855, w: 66, h: 37, group: 'g855'},
            {type: 'y', x: 612, y: 855, w: 66, h: 37, group: 'g855', default: 'yes'},
            {type: 'y', x: 682, y: 900, w: 66, h: 37, group: 'g900'},
            {type: 'y', x: 612, y: 900, w: 66, h: 37, group: 'g900', default: 'yes'},
            {type: 'y', x: 682, y: 944, w: 66, h: 37, group: 'g944'},
            {type: 'y', x: 612, y: 944, w: 66, h: 37, group: 'g944', default: 'yes'},
            {type: 'y', x: 682, y: 985, w: 66, h: 37, group: 'g985'},
            {type: 'y', x: 612, y: 985, w: 66, h: 37, group: 'g985', default: 'yes'},
            {type: 't', x: 152, y: 1086, w: 1019, h: 37},
            {type: 't', x: 152, y: 1153, w: 909, h: 26, default: props.user.name, readonly: true},
            {type: 'i', x: 907, y: 1179, w: 200, h: 52, default: props.user.signature, readonly: true},
            {type: 't', x: 152, y: 1235, w: 665, h: 26, default: props.delegate.name, readonly: true},
            {type: 'i', x: 907, y: 1281, w: 200, h: 52, default: props.delegate.signature, readonly: true},
        ]
    },
    {
        text: 'صحيفة قياس للعدادات',
        image: measurementsSheetForMeters,
        fields: [
            {type: 't', x: 924, y: 180, w: 180, h: 20, default: props.dep, align: 'center'},
            {type: 't', x: 688, y: 180, w: 120, h: 20, default: props.div, align: 'center'},
            {type: 't', x: 411, y: 180, w: 160, h: 20, default: props.district, align: 'center'},
            {type: 't', x: 75, y: 206, w: 233, h: 20, default: props.number, align: 'center'},
            {type: 't', x: 800, y: 275, w: 62, h: 28},
            {type: 't', x: 322, y: 275, w: 69, h: 28},
            {type: 't', x: 59, y: 275, w: 62, h: 28},
            {type: 't', x: 800, y: 307, w: 62, h: 48},
            {type: 't', x: 322, y: 307, w: 69, h: 48},
            {type: 't', x: 59, y: 307, w: 62, h: 48},
            {type: 't', x: 800, y: 359, w: 62, h: 50},
            {type: 't', x: 322, y: 359, w: 69, h: 50},
            {type: 't', x: 59, y: 359, w: 62, h: 50},
            {type: 't', x: 800, y: 412, w: 62, h: 50},
            {type: 't', x: 322, y: 412, w: 69, h: 50},
            {type: 't', x: 59, y: 412, w: 62, h: 50},
            {type: 't', x: 800, y: 466, w: 62, h: 55},
            {type: 't', x: 322, y: 466, w: 69, h: 55},
            {type: 't', x: 59, y: 466, w: 62, h: 55},
            {type: 't', x: 800, y: 523, w: 62, h: 55},
            {type: 't', x: 322, y: 523, w: 69, h: 55},
            {type: 't', x: 59, y: 523, w: 62, h: 55},
            {type: 't', x: 800, y: 582, w: 62, h: 53},
            {type: 't', x: 322, y: 582, w: 69, h: 53},
            {type: 't', x: 59, y: 582, w: 62, h: 53},
            {type: 't', x: 800, y: 638, w: 62, h: 57},
            {type: 't', x: 322, y: 638, w: 69, h: 57},
            {type: 't', x: 59, y: 638, w: 62, h: 57},
            {type: 't', x: 800, y: 698, w: 62, h: 26},
            {type: 't', x: 322, y: 698, w: 69, h: 26},
            {type: 't', x: 59, y: 698, w: 62, h: 26},
            {type: 't', x: 800, y: 727, w: 62, h: 54},
            {type: 't', x: 322, y: 727, w: 69, h: 54},
            {type: 't', x: 59, y: 727, w: 62, h: 54},
            {type: 't', x: 800, y: 784, w: 62, h: 26},
            {type: 't', x: 322, y: 784, w: 69, h: 26},
            {type: 't', x: 59, y: 784, w: 62, h: 26},
            {type: 't', x: 800, y: 813, w: 62, h: 42},
            {type: 't', x: 322, y: 813, w: 69, h: 42},
            {type: 't', x: 59, y: 813, w: 62, h: 42},
            {type: 't', x: 800, y: 857, w: 62, h: 42},
            {type: 't', x: 322, y: 857, w: 69, h: 42},
            {type: 't', x: 59, y: 857, w: 62, h: 42},
            {type: 't', x: 800, y: 901, w: 62, h: 27},
            {type: 't', x: 322, y: 901, w: 69, h: 27},
            {type: 't', x: 59, y: 901, w: 62, h: 27},
            {type: 't', x: 800, y: 931, w: 62, h: 25},
            {type: 't', x: 322, y: 931, w: 69, h: 25},
            {type: 't', x: 59, y: 931, w: 62, h: 25},
            {type: 't', x: 800, y: 958, w: 62, h: 26},
            {type: 't', x: 322, y: 958, w: 69, h: 26},
            {type: 't', x: 59, y: 958, w: 62, h: 26},
            {type: 't', x: 800, y: 987, w: 62, h: 26},
            {type: 't', x: 322, y: 987, w: 69, h: 26},
            {type: 't', x: 59, y: 987, w: 62, h: 26},
            {type: 't', x: 800, y: 1017, w: 62, h: 26},
            {type: 't', x: 322, y: 1017, w: 69, h: 26},
            {type: 't', x: 59, y: 1017, w: 62, h: 26},
            {type: 't', x: 800, y: 1046, w: 62, h: 26},
            {type: 't', x: 322, y: 1046, w: 69, h: 26},
            {type: 't', x: 59, y: 1046, w: 62, h: 26},
            {type: 't', x: 800, y: 1075, w: 62, h: 26},
            {type: 't', x: 322, y: 1075, w: 69, h: 26},
            {type: 't', x: 59, y: 1075, w: 62, h: 26},
            {type: 't', x: 800, y: 1104, w: 62, h: 26},
            {type: 't', x: 322, y: 1104, w: 69, h: 26},
            {type: 't', x: 59, y: 1104, w: 62, h: 26},
            {type: 't', x: 800, y: 1133, w: 62, h: 56},
            {type: 't', x: 322, y: 1133, w: 69, h: 56},
            {type: 't', x: 59, y: 1133, w: 62, h: 56},
            {type: 't', x: 800, y: 1192, w: 62, h: 25},
            {type: 't', x: 322, y: 1192, w: 69, h: 25},
            {type: 't', x: 59, y: 1192, w: 62, h: 25},
            {type: 't', x: 800, y: 1220, w: 62, h: 25},
            {type: 't', x: 322, y: 1220, w: 69, h: 25},
            {type: 't', x: 59, y: 1220, w: 62, h: 25},
            {type: 't', x: 800, y: 1249, w: 62, h: 25},
            {type: 't', x: 322, y: 1249, w: 69, h: 25},
            {type: 't', x: 59, y: 1249, w: 62, h: 25},
            {type: 't', x: 237, y: 1281, w: 785, h: 30, align: 'center'},
            {type: 't', x: 415, y: 1340, w: 660, h: 25, default: props.user.name, readonly: true},
            {type: 'i', x: 160, y: 1320, w: 200, h: 52, default: props.user.signature, readonly: true},
            {type: 't', x: 420, y: 1400, w: 400, h: 25, default: props.delegate.name, readonly: true},
            {type: 'i', x: 160, y: 1376, w: 200, h: 52, default: props.delegate.signature, readonly: true},
        ]
    },
    {
        text: 'نموذج تركيب عداد عادي / عداد محول تيار',
        image: lvMeterInstallation,
        fields: [
            {type: 't', x: 638, y: 361, w: 345, h: 20, default: props.dep},
            {type: 't', x: 151, y: 361, w: 389, h: 20, default: props.div},
            {type: 't', x: 698, y: 387, w: 427, h: 20, default: props.district},
            {type: 't', x: 151, y: 387, w: 278, h: 20, default: props.number},
            {type: 't', x: 705, y: 412, w: 420, h: 20, default: props.contractor},
            {type: 'y', x: 639, y: 510, w: 61, h: 45, group: 'g510'},
            {type: 'y', x: 575, y: 510, w: 61, h: 45, group: 'g510', default: 'yes'},
            {type: 'y', x: 639, y: 559, w: 61, h: 45, group: 'g559'},
            {type: 'y', x: 575, y: 559, w: 61, h: 45, group: 'g559', default: 'yes'},
            {type: 'y', x: 639, y: 606, w: 61, h: 45, group: 'g606'},
            {type: 'y', x: 575, y: 606, w: 61, h: 45, group: 'g606', default: 'yes'},
            {type: 'y', x: 639, y: 667, w: 61, h: 45, group: 'g667'},
            {type: 'y', x: 575, y: 667, w: 61, h: 45, group: 'g667', default: 'yes'},
            {type: 'y', x: 639, y: 738, w: 61, h: 45, group: 'g738'},
            {type: 'y', x: 575, y: 738, w: 61, h: 45, group: 'g738', default: 'yes'},
            {type: 'y', x: 639, y: 800, w: 61, h: 45, group: 'g800'},
            {type: 'y', x: 575, y: 800, w: 61, h: 45, group: 'g800', default: 'na'},
            {type: 'y', x: 639, y: 856, w: 61, h: 45, group: 'g856'},
            {type: 'y', x: 575, y: 856, w: 61, h: 45, group: 'g856', default: 'na'},
            {type: 'y', x: 639, y: 909, w: 61, h: 45, group: 'g909'},
            {type: 'y', x: 575, y: 909, w: 61, h: 45, group: 'g909', default: 'yes'},
            {type: 'y', x: 639, y: 957, w: 61, h: 45, group: 'g957'},
            {type: 'y', x: 575, y: 957, w: 61, h: 45, group: 'g957', default: 'yes'},
            {type: 't', x: 151, y: 1056, w: 825, h: 25, default: props.user.name, readonly: true},
            {type: 'i', x: 832, y: 1073, w: 200, h: 52, default: props.user.signature, readonly: true},
            {type: 't', x: 151, y: 1130, w: 551, h: 25, default: props.delegate.name, readonly: true},
            {type: 'i', x: 832, y: 1148, w: 200, h: 52, default: props.delegate.signature, readonly: true},
        ]
    },
    {
        text: 'إجراء رقم (١٩٠)',
        image: procedure190,
        fields: [
            {type: 't', x: 621, y: 275, w: 381, h: 37, default: props.number},
            {type: 't', x: 94, y: 275, w: 323, h: 37, default: props.district},
            {type: 't', x: 621, y: 319, w: 381, h: 37, default: props.contractor},
            {type: 't', x: 94, y: 319, w: 323, h: 37, default: props.feeder},
            {type: 'y', x: 485, y: 430, w: 96, h: 49, group: 'g430', default: 'yes'},
            {type: 'y', x: 392, y: 430, w: 96, h: 49, group: 'g430'},
            {type: 't', x: 97, y: 430, w: 289, h: 49, align: 'center'},
            {type: 'y', x: 485, y: 483, w: 96, h: 49, group: 'g483', default: 'yes'},
            {type: 'y', x: 392, y: 483, w: 96, h: 49, group: 'g483'},
            {type: 't', x: 97, y: 483, w: 289, h: 49, align: 'center'},
            {type: 'y', x: 485, y: 537, w: 96, h: 49, group: 'g537', default: 'yes'},
            {type: 'y', x: 392, y: 537, w: 96, h: 49, group: 'g537'},
            {type: 't', x: 97, y: 537, w: 289, h: 49, align: 'center'},
            {type: 'y', x: 485, y: 590, w: 96, h: 49, group: 'g590', default: 'na'},
            {type: 'y', x: 392, y: 590, w: 96, h: 49, group: 'g590'},
            {type: 't', x: 97, y: 590, w: 289, h: 49, align: 'center'},
            {type: 'y', x: 485, y: 642, w: 96, h: 49, group: 'g642', default: 'yes'},
            {type: 'y', x: 392, y: 642, w: 96, h: 49, group: 'g642'},
            {type: 't', x: 97, y: 642, w: 289, h: 49, align: 'center'},
            {type: 'y', x: 485, y: 696, w: 96, h: 49, group: 'g696', default: 'yes'},
            {type: 'y', x: 392, y: 696, w: 96, h: 49, group: 'g696'},
            {type: 't', x: 97, y: 696, w: 289, h: 49, align: 'center'},
            {type: 'y', x: 485, y: 765, w: 96, h: 49, group: 'g765', default: 'yes'},
            {type: 'y', x: 392, y: 765, w: 96, h: 49, group: 'g765'},
            {type: 't', x: 97, y: 765, w: 289, h: 49, align: 'center'},
            {type: 'y', x: 485, y: 851, w: 96, h: 49, group: 'g851', default: 'yes'},
            {type: 'y', x: 392, y: 851, w: 96, h: 49, group: 'g851'},
            {type: 't', x: 97, y: 851, w: 289, h: 49, align: 'center'},
            {type: 'y', x: 485, y: 938, w: 96, h: 49, group: 'g938', default: 'yes'},
            {type: 'y', x: 392, y: 938, w: 96, h: 49, group: 'g938'},
            {type: 't', x: 97, y: 938, w: 289, h: 49, align: 'center'},
            {type: 't', x: 547, y: 1170, w: 268, h: 52, default: props.supervisor.name, readonly: true},
            {type: 'i', x: 139, y: 1170, w: 200, h: 52, default: props.supervisor.signature, readonly: true},
            {type: 't', x: 547, y: 1226, w: 268, h: 52, default: props.user.name, readonly: true},
            {type: 'i', x: 139, y: 1226, w: 200, h: 52, default: props.user.signature, readonly: true},
            {type: 't', x: 547, y: 1282, w: 268, h: 52, default: props.delegate.name, readonly: true},
            {type: 'i', x: 139, y: 1282, w: 200, h: 52, default: props.delegate.signature, readonly: true},
        ]
    },
    {
        text: 'نموذج القياس',
        image: measurementSheet,
        fields: [
            {type: 't', x: 1170, y: 140, w: 310, h: 20, default: props.dep, fontSize: 10},
            {type: 't', x: 827, y: 140, w: 210, h: 20, default: props.number, fontSize: 10},
            {type: 't', x: 1170, y: 168, w: 310, h: 20, default: props.div, fontSize: 10},
            {type: 't', x: 827, y: 168, w: 210, h: 20, default: props.feeder, fontSize: 10},
            {type: 't', x: 1170, y: 197, w: 310, h: 20, default: props.contractor, fontSize: 10},
            {type: 't', x: 827, y: 197, w: 210, h: 20, default: props.district, fontSize: 10},
            {type: 't', x: 1550, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1486, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1423, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1359, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1295, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1231, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1168, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1104, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1040, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 953, y: 504, w: 83, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 889, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 825, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 765, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 698, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 634, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 570, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 506, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 443, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 379, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 315, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1550, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1486, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1423, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1359, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1295, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1231, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1168, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1104, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1040, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 953, y: 526, w: 83, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 889, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 825, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 765, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 698, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 634, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 570, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 506, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 443, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 379, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 315, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1550, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1486, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1423, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1359, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1295, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1231, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1168, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1104, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1040, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 953, y: 549, w: 83, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 889, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 825, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 765, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 698, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 634, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 570, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 506, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 443, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 379, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 315, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1550, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1486, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1423, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1359, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1295, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1231, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1168, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1104, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1040, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 953, y: 572, w: 83, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 889, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 825, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 765, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 698, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 634, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 570, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 506, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 443, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 379, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 315, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1550, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1486, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1423, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1359, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1295, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1231, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1168, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1104, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1040, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 953, y: 595, w: 83, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 889, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 825, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 765, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 698, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 634, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 570, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 506, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 443, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 379, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 315, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1550, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1486, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1423, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1359, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1295, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1231, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1168, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1104, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1040, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 953, y: 619, w: 83, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 889, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 825, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 765, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 698, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 634, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 570, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 506, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 443, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 379, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 315, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1550, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1486, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1423, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1359, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1295, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1231, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1168, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1104, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1040, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 953, y: 642, w: 83, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 889, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 825, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 765, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 698, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 634, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 570, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 506, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 443, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 379, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 315, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1550, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1486, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1423, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1359, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1295, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1231, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1168, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1104, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1040, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 953, y: 665, w: 83, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 889, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 825, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 765, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 698, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 634, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 570, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 506, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 443, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 379, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 315, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1550, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1486, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1423, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1359, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1295, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1231, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1168, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1104, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1040, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 953, y: 687, w: 83, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 889, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 825, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 765, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 698, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 634, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 570, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 506, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 443, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 379, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 315, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1550, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1486, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1423, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1359, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1295, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1231, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1168, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1104, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1040, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 953, y: 710, w: 83, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 889, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 825, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 765, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 698, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 634, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 570, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 506, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 443, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 379, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 315, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 'ta', x: 44, y: 337, w: 267, h: 391, fontSize: 10},
            {type: 't', x: 1210, y: 770, w: 230, h: 20, default: props.supervisor.name, readonly: true, fontSize: 10},
            {type: 'i', x: 1000, y: 750, w: 200, h: 52, default: props.supervisor.signature, readonly: true, fontSize: 10},
            {type: 't', x: 275, y: 770, w: 230, h: 20, default: props.user.name, readonly: true, fontSize: 10},
            {type: 'i', x: 65, y: 750, w: 200, h: 52, default: props.user.signature, readonly: true, fontSize: 10},
        ]
    },
    {
        text: 'فحص محطة التوزيع والمعدات الكهربائية',
        image: substationAndElectricalEquipmentInspection,
        fields: [
            {type: 't', x: 676, y: 190, w: 310, h: 20, default: props.dep},
            {type: 't', x: 150, y: 190, w: 420, h: 20, default: props.div},
            {type: 't', x: 853, y: 230, w: 233, h: 20, default: props.district, align: 'center'},
            {type: 't', x: 334, y: 230, w: 233, h: 20, align: 'center'},
            {type: 't', x: 849, y: 277, w: 233, h: 20, default: props.contractor, align: 'center'},
            {type: 't', x: 336, y: 277, w: 230, h: 20, default: props.number, align: 'center'},
            {type: 'y', x: 672, y: 376, w: 50, h: 20, group: 'g376'},
            {type: 'y', x: 609, y: 376, w: 61, h: 20, group: 'g376'},
            {type: 'y', x: 672, y: 401, w: 50, h: 20, group: 'g401'},
            {type: 'y', x: 609, y: 401, w: 61, h: 20, group: 'g401'},
            {type: 'y', x: 672, y: 425, w: 50, h: 20, group: 'g425'},
            {type: 'y', x: 609, y: 425, w: 61, h: 20, group: 'g425'},
            {type: 'y', x: 672, y: 457, w: 50, h: 20, group: 'g457'},
            {type: 'y', x: 609, y: 457, w: 61, h: 20, group: 'g457'},
            {type: 'y', x: 672, y: 495, w: 50, h: 20, group: 'g495'},
            {type: 'y', x: 609, y: 495, w: 61, h: 20, group: 'g495'},
            {type: 'y', x: 672, y: 527, w: 50, h: 20, group: 'g527'},
            {type: 'y', x: 609, y: 527, w: 61, h: 20, group: 'g527'},
            {type: 'y', x: 672, y: 551, w: 50, h: 20, group: 'g551'},
            {type: 'y', x: 609, y: 551, w: 61, h: 20, group: 'g551'},
            {type: 'y', x: 672, y: 576, w: 50, h: 20, group: 'g576'},
            {type: 'y', x: 609, y: 576, w: 61, h: 20, group: 'g576'},
            {type: 'y', x: 672, y: 600, w: 50, h: 20, group: 'g600'},
            {type: 'y', x: 609, y: 600, w: 61, h: 20, group: 'g600'},
            {type: 'y', x: 672, y: 632, w: 50, h: 20, group: 'g632'},
            {type: 'y', x: 609, y: 632, w: 61, h: 20, group: 'g632'},
            {type: 'y', x: 672, y: 688, w: 50, h: 20, group: 'g688'},
            {type: 'y', x: 609, y: 688, w: 61, h: 20, group: 'g688'},
            {type: 'y', x: 672, y: 712, w: 50, h: 20, group: 'g712'},
            {type: 'y', x: 609, y: 712, w: 61, h: 20, group: 'g712'},
            {type: 'y', x: 672, y: 737, w: 50, h: 20, group: 'g737'},
            {type: 'y', x: 609, y: 737, w: 61, h: 20, group: 'g737'},
            {type: 'y', x: 672, y: 761, w: 50, h: 20, group: 'g761'},
            {type: 'y', x: 609, y: 761, w: 61, h: 20, group: 'g761'},
            {type: 'y', x: 672, y: 786, w: 50, h: 20, group: 'g786'},
            {type: 'y', x: 609, y: 786, w: 61, h: 20, group: 'g786'},
            {type: 'y', x: 672, y: 810, w: 50, h: 20, group: 'g810'},
            {type: 'y', x: 609, y: 810, w: 61, h: 20, group: 'g810'},
            {type: 'y', x: 672, y: 835, w: 50, h: 20, group: 'g835'},
            {type: 'y', x: 609, y: 835, w: 61, h: 20, group: 'g835'},
            {type: 'y', x: 672, y: 884, w: 50, h: 20, group: 'g884'},
            {type: 'y', x: 609, y: 884, w: 61, h: 20, group: 'g884'},
            {type: 'y', x: 672, y: 909, w: 50, h: 20, group: 'g909'},
            {type: 'y', x: 609, y: 909, w: 61, h: 20, group: 'g909'},
            {type: 'y', x: 672, y: 939, w: 50, h: 20, group: 'g939'},
            {type: 'y', x: 609, y: 939, w: 61, h: 20, group: 'g939'},
            {type: 'y', x: 672, y: 972, w: 50, h: 20, group: 'g972'},
            {type: 'y', x: 609, y: 972, w: 61, h: 20, group: 'g972'},
            {type: 'y', x: 672, y: 996, w: 50, h: 20, group: 'g996'},
            {type: 'y', x: 609, y: 996, w: 61, h: 20, group: 'g996'},
            {type: 'y', x: 672, y: 1046, w: 50, h: 20, group: 'g1046'},
            {type: 'y', x: 609, y: 1046, w: 61, h: 20, group: 'g1046'},
            {type: 'y', x: 672, y: 1070, w: 50, h: 20, group: 'g1070'},
            {type: 'y', x: 609, y: 1070, w: 61, h: 20, group: 'g1070'},
            {type: 'y', x: 672, y: 1094, w: 50, h: 20, group: 'g1094'},
            {type: 'y', x: 609, y: 1094, w: 61, h: 20, group: 'g1094'},
            {type: 'y', x: 672, y: 1119, w: 50, h: 20, group: 'g1119'},
            {type: 'y', x: 609, y: 1119, w: 61, h: 20, group: 'g1119'},
            {type: 'y', x: 672, y: 1143, w: 50, h: 20, group: 'g1143'},
            {type: 'y', x: 609, y: 1143, w: 61, h: 20, group: 'g1143'},
            {type: 'y', x: 672, y: 1168, w: 50, h: 20, group: 'g1168'},
            {type: 'y', x: 609, y: 1168, w: 61, h: 20, group: 'g1168'},
            {type: 'y', x: 672, y: 1193, w: 50, h: 20, group: 'g1193'},
            {type: 'y', x: 609, y: 1193, w: 61, h: 20, group: 'g1193'},
            {type: 'y', x: 672, y: 1242, w: 50, h: 20, group: 'g1242'},
            {type: 'y', x: 609, y: 1242, w: 61, h: 20, group: 'g1242'},
            {type: 'y', x: 672, y: 1266, w: 50, h: 20, group: 'g1266'},
            {type: 'y', x: 609, y: 1266, w: 61, h: 20, group: 'g1266'},
            {type: 't', x: 885, y: 1350, w: 241, h: 22, default: props.user.name, readonly: true},
            {type: 'i', x: 676, y: 1334, w: 200, h: 52, default: props.user.signature, readonly: true},
            {type: 't', x: 316, y: 1350, w: 343, h: 22, default: props.delegate.name, readonly: true},
            {type: 'i', x: 175, y: 1334, w: 200, h: 52, default: props.delegate.signature, readonly: true},
        ]
    },
    {
        text: 'تأريض المحطات',
        image: substationEarthing,
        fields: [
            {type: 't', x: 695, y: 221, w: 334, h: 30, default: props.dep},
            {type: 't', x: 152, y: 221, w: 439, h: 30, default: props.div},
            {type: 't', x: 797, y: 265, w: 220, h: 30, default: props.district, align: 'center'},
            {type: 't', x: 275, y: 265, w: 206, h: 30, align: 'center'},
            {type: 't', x: 815, y: 314, w: 196, h: 30, default: props.contractor, align: 'center'},
            {type: 't', x: 317, y: 314, w: 165, h: 30, default: props.number, align: 'center'},
            {type: 'y', x: 694, y: 410, w: 68, h: 45, group: 'g410'},
            {type: 'y', x: 624, y: 410, w: 67, h: 45, group: 'g410', default: 'yes'},
            {type: 'y', x: 694, y: 472, w: 68, h: 45, group: 'g472'},
            {type: 'y', x: 624, y: 472, w: 67, h: 45, group: 'g472', default: 'yes'},
            {type: 'y', x: 694, y: 524, w: 68, h: 45, group: 'g524'},
            {type: 'y', x: 624, y: 524, w: 67, h: 45, group: 'g524', default: 'yes'},
            {type: 'y', x: 694, y: 577, w: 68, h: 45, group: 'g577'},
            {type: 'y', x: 624, y: 577, w: 67, h: 45, group: 'g577', default: 'yes'},
            {type: 'y', x: 694, y: 640, w: 68, h: 45, group: 'g640'},
            {type: 'y', x: 624, y: 640, w: 67, h: 45, group: 'g640', default: 'yes'},
            {type: 'y', x: 694, y: 703, w: 68, h: 45, group: 'g703'},
            {type: 'y', x: 624, y: 703, w: 67, h: 45, group: 'g703', default: 'yes'},
            {type: 'y', x: 694, y: 755, w: 68, h: 45, group: 'g755'},
            {type: 'y', x: 624, y: 755, w: 67, h: 45, group: 'g755', default: 'yes'},
            {type: 'ta', x: 158, y: 1052, w: 1021, h: 91},
            {type: 't', x: 153, y: 1153, w: 908, h: 26, default: props.user.name, readonly: true},
            {type: 'i', x: 901, y: 1178, w: 200, h: 52, default: props.user.signature, readonly: true},
            {type: 't', x: 153, y: 1238, w: 639, h: 26, default: props.delegate.name, readonly: true},
            {type: 'i', x: 901, y: 1267, w: 200, h: 52, default: props.delegate.signature, readonly: true},
        ]
    },
    {
        text: 'قواعد المحطات',
        image: substationFoundation,
        fields: [
            {type: 't', x: 745, y: 288, w: 241, h: 21, default: props.dep, align: 'center'},
            {type: 't', x: 272, y: 288, w: 349, h: 21, default: props.div, align: 'center'},
            {type: 't', x: 784, y: 313, w: 247, h: 21, default: props.district, align: 'center'},
            {type: 't', x: 330, y: 313, w: 235, h: 21, default: props.number, align: 'center'},
            {type: 't', x: 806, y: 337, w: 218, h: 21, default: props.contractor, align: 'center'},
            {type: 't', x: 346, y: 337, w: 235, h: 21, default: props.feeder, align: 'center'},
            {type: 'y', x: 671, y: 410, w: 63, h: 44, group: 'g410', default: 'yes'},
            {type: 'y', x: 607, y: 410, w: 63, h: 44, group: 'g410'},
            {type: 'y', x: 671, y: 506, w: 63, h: 44, group: 'g506', default: 'yes'},
            {type: 'y', x: 607, y: 506, w: 63, h: 44, group: 'g506'},
            {type: 'y', x: 671, y: 558, w: 63, h: 44, group: 'g558', default: 'yes'},
            {type: 'y', x: 607, y: 558, w: 63, h: 44, group: 'g558'},
            {type: 'y', x: 671, y: 612, w: 63, h: 44, group: 'g612', default: 'yes'},
            {type: 'y', x: 607, y: 612, w: 63, h: 44, group: 'g612'},
            {type: 'y', x: 671, y: 660, w: 63, h: 44, group: 'g660', default: 'yes'},
            {type: 'y', x: 607, y: 660, w: 63, h: 44, group: 'g660'},
            {type: 'y', x: 671, y: 708, w: 63, h: 44, group: 'g708', default: 'yes'},
            {type: 'y', x: 607, y: 708, w: 63, h: 44, group: 'g708'},
            {type: 'ta', x: 160, y: 959, w: 933, h: 64},
            {type: 't', x: 154, y: 1052, w: 821, h: 25, readonly: true, default: props.user.name},
            {type: 'i', x: 828, y: 1096, w: 200, h: 52, readonly: true, default: props.user.signature},
            {type: 't', x: 154, y: 1170, w: 555, h: 25, readonly: true, default: props.delegate.name},
            {type: 'i', x: 828, y: 1203, w: 200, h: 52, readonly: true, default: props.delegate.signature},
        ]
    },
    {
        text: 'نموذج فحص الأعمال الهوائية',
        image: listOHInspection,
        fields: [
            {type: 't', x: 902, y: 163, w: 148, h: 20, default: props.dep},
            {type: 't', x: 58, y: 163, w: 191, h: 20, default: props.div},
            {type: 't', x: 902, y: 202, w: 198, h: 20},
            {type: 't', x: 57, y: 202, w: 223, h: 20, default: props.contractor},
            {type: 'y', x: 988, y: 357, w: 59, h: 20, group: 'g357'},
            {type: 'y', x: 899, y: 357, w: 87, h: 20, group: 'g357'},
            {type: 'y', x: 988, y: 390, w: 59, h: 20, group: 'g390'},
            {type: 'y', x: 899, y: 390, w: 87, h: 20, group: 'g390'},
            {type: 'ta', x: 901, y: 441, w: 287, h: 133},
            {type: 'y', x: 674, y: 357, w: 56, h: 20, group: 'ga357'},
            {type: 'y', x: 619, y: 357, w: 56, h: 20, group: 'ga357'},
            {type: 'y', x: 674, y: 379, w: 56, h: 20, group: 'ga379'},
            {type: 'y', x: 619, y: 379, w: 56, h: 20, group: 'ga379'},
            {type: 'y', x: 674, y: 412, w: 56, h: 20, group: 'ga412'},
            {type: 'y', x: 619, y: 412, w: 56, h: 20, group: 'ga412'},
            {type: 'y', x: 674, y: 456, w: 56, h: 20, group: 'ga456'},
            {type: 'y', x: 619, y: 456, w: 56, h: 20, group: 'ga456'},
            {type: 'y', x: 674, y: 503, w: 56, h: 20, group: 'ga503'},
            {type: 'y', x: 619, y: 503, w: 56, h: 20, group: 'ga503'},
            {type: 'y', x: 674, y: 547, w: 56, h: 20, group: 'ga547'},
            {type: 'y', x: 619, y: 547, w: 56, h: 20, group: 'ga547'},
            {type: 'y', x: 401, y: 357, w: 68, h: 20, group: 'gb357'},
            {type: 'y', x: 339, y: 357, w: 60, h: 20, group: 'gb357'},
            {type: 'y', x: 401, y: 379, w: 68, h: 20, group: 'gb379'},
            {type: 'y', x: 339, y: 379, w: 60, h: 20, group: 'gb379'},
            {type: 'y', x: 401, y: 401, w: 68, h: 20, group: 'gb401'},
            {type: 'y', x: 339, y: 401, w: 60, h: 20, group: 'gb401'},
            {type: 'y', x: 401, y: 435, w: 68, h: 20, group: 'gb435'},
            {type: 'y', x: 339, y: 435, w: 60, h: 20, group: 'gb435'},
            {type: 'y', x: 401, y: 478, w: 68, h: 20, group: 'gb478'},
            {type: 'y', x: 339, y: 478, w: 60, h: 20, group: 'gb478'},
            {type: 'ta', x: 340, y: 525, w: 274, h: 48},
            {type: 'y', x: 127, y: 357, w: 62, h: 20, group: 'gc357'},
            {type: 'y', x: 56, y: 357, w: 68, h: 20, group: 'gc357'},
            {type: 'y', x: 127, y: 379, w: 62, h: 20, group: 'gc379'},
            {type: 'y', x: 56, y: 379, w: 68, h: 20, group: 'gc379'},
            {type: 'y', x: 127, y: 401, w: 62, h: 20, group: 'gc401'},
            {type: 'y', x: 56, y: 401, w: 68, h: 20, group: 'gc401'},
            {type: 'y', x: 127, y: 435, w: 62, h: 20, group: 'gc435'},
            {type: 'y', x: 56, y: 435, w: 68, h: 20, group: 'gc435'},
            {type: 'y', x: 127, y: 478, w: 62, h: 20, group: 'gc478'},
            {type: 'y', x: 56, y: 478, w: 68, h: 20, group: 'gc478'},
            {type: 'y', x: 954, y: 732, w: 54, h: 20, group: 'gd732'},
            {type: 'y', x: 899, y: 732, w: 54, h: 20, group: 'gd732'},
            {type: 'y', x: 954, y: 754, w: 54, h: 20, group: 'gd754'},
            {type: 'y', x: 899, y: 754, w: 54, h: 20, group: 'gd754'},
            {type: 'y', x: 954, y: 787, w: 54, h: 20, group: 'gd787'},
            {type: 'y', x: 899, y: 787, w: 54, h: 20, group: 'gd787'},
            {type: 'y', x: 954, y: 831, w: 54, h: 20, group: 'gd831'},
            {type: 'y', x: 899, y: 831, w: 54, h: 20, group: 'gd831'},
            {type: 'y', x: 954, y: 866, w: 54, h: 20, group: 'gd866'},
            {type: 'y', x: 899, y: 866, w: 54, h: 20, group: 'gd866'},
            {type: 'ta', x: 901, y: 904, w: 286, h: 159},
            {type: 'y', x: 685, y: 732, w: 54, h: 20, group: 'ge732'},
            {type: 'y', x: 619, y: 732, w: 66, h: 20, group: 'ge732'},
            {type: 'ta', x: 621, y: 772, w: 272, h: 293},
            {type: 'y', x: 395, y: 744, w: 53, h: 20, group: 'gf744'},
            {type: 'y', x: 340, y: 744, w: 53, h: 20, group: 'gf744'},
            {type: 'y', x: 395, y: 788, w: 53, h: 20, group: 'gf788'},
            {type: 'y', x: 340, y: 788, w: 53, h: 20, group: 'gf788'},
            {type: 'y', x: 395, y: 822, w: 53, h: 20, group: 'gf822'},
            {type: 'y', x: 340, y: 822, w: 53, h: 20, group: 'gf822'},
            {type: 'y', x: 395, y: 844, w: 53, h: 20, group: 'gf844'},
            {type: 'y', x: 340, y: 844, w: 53, h: 20, group: 'gf844'},
            {type: 'ta', x: 341, y: 887, w: 272, h: 179},
            {type: 'y', x: 110, y: 743, w: 57, h: 20, group: 'gg743'},
            {type: 'y', x: 56, y: 743, w: 53, h: 20, group: 'gg743'},
            {type: 'y', x: 110, y: 787, w: 57, h: 20, group: 'gg787'},
            {type: 'y', x: 56, y: 787, w: 53, h: 20, group: 'gg787'},
            {type: 'y', x: 110, y: 832, w: 57, h: 20, group: 'gg832'},
            {type: 'y', x: 56, y: 832, w: 53, h: 20, group: 'gg832'},
            {type: 'y', x: 110, y: 876, w: 57, h: 20, group: 'gg876'},
            {type: 'y', x: 56, y: 876, w: 53, h: 20, group: 'gg876'},
            {type: 'y', x: 110, y: 922, w: 57, h: 20, group: 'gg922'},
            {type: 'y', x: 56, y: 922, w: 53, h: 20, group: 'gg922'},
            {type: 'y', x: 110, y: 969, w: 57, h: 20, group: 'gg969'},
            {type: 'y', x: 56, y: 969, w: 53, h: 20, group: 'gg969'},
            {type: 'y', x: 110, y: 1025, w: 57, h: 20, group: 'gg1025'},
            {type: 'y', x: 56, y: 1025, w: 53, h: 20, group: 'gg1025'},
            {type: 'y', x: 340, y: 1112, w: 277, h: 23, group: 'g1112'},
            {type: 'y', x: 56, y: 1112, w: 281, h: 23, group: 'g1112'},
            {type: 'y', x: 340, y: 1136, w: 277, h: 23, group: 'g1136'},
            {type: 'y', x: 56, y: 1136, w: 281, h: 23, group: 'g1136'},
            {type: 'y', x: 340, y: 1158, w: 277, h: 23, group: 'g1158'},
            {type: 'y', x: 56, y: 1158, w: 281, h: 23, group: 'g1158'},
            {type: 'y', x: 340, y: 1180, w: 277, h: 23, group: 'g1180'},
            {type: 'y', x: 56, y: 1180, w: 281, h: 23, group: 'g1180'},
            {type: 'y', x: 340, y: 1207, w: 277, h: 23, group: 'g1207'},
            {type: 'y', x: 56, y: 1207, w: 281, h: 23, group: 'g1207'},
            {type: 't', x: 619, y: 1114, w: 401, h: 20},
            {type: 't', x: 619, y: 1137, w: 295, h: 20},
            {type: 't', x: 619, y: 1160, w: 353, h: 20},
            {type: 't', x: 619, y: 1183, w: 398, h: 20},
            {type: 't', x: 619, y: 1208, w: 413, h: 20},
            {type: 't', x: 619, y: 1235, w: 461, h: 20, default: props.user.name, readonly: true},
            {type: 'i', x: 308, y: 1236, w: 250, h: 65, default: props.user.signature, readonly: true},
            {type: 't', x: 619, y: 1307, w: 230, h: 20, default: props.delegate.name, readonly: true},
            {type: 'i', x: 308, y: 1308, w: 250, h: 65, default: props.delegate.signature, readonly: true},
        ]
    },
    {
        text: 'نموذج فحص تفصيلي الخطوط الهوائية (المنفذة)',
        image: detailsOfOverheadLines,
        fields: [
            {type: 't', x: 916, y: 172, w: 130, h: 20, default: props.dep},
            {type: 't', x: 95, y: 172, w: 321, h: 20, default: props.div},
            {type: 't', x: 950, y: 242, w: 100, h: 20, default: props.contractor, align: 'center'},
            {type: 't', x: 637, y: 227, w: 83, h: 20, default: props.number},
            {type: 't', x: 350, y: 242, w: 191, h: 20, align: 'center'},
            {type: 'y', x: 783, y: 385, w: 30, h: 20, group: 'g385'},
            {type: 'y', x: 749, y: 385, w: 30, h: 20, group: 'g385'},
            {type: 'y', x: 783, y: 407, w: 30, h: 20, group: 'g407'},
            {type: 'y', x: 749, y: 407, w: 30, h: 20, group: 'g407'},
            {type: 'y', x: 783, y: 429, w: 30, h: 20, group: 'g429'},
            {type: 'y', x: 749, y: 429, w: 30, h: 20, group: 'g429'},
            {type: 'y', x: 783, y: 451, w: 30, h: 20, group: 'g451'},
            {type: 'y', x: 749, y: 451, w: 30, h: 20, group: 'g451'},
            {type: 'y', x: 783, y: 473, w: 30, h: 20, group: 'g473'},
            {type: 'y', x: 749, y: 473, w: 30, h: 20, group: 'g473'},
            {type: 'y', x: 783, y: 495, w: 30, h: 20, group: 'g495'},
            {type: 'y', x: 749, y: 495, w: 30, h: 20, group: 'g495'},
            {type: 'y', x: 783, y: 517, w: 30, h: 20, group: 'g517'},
            {type: 'y', x: 749, y: 517, w: 30, h: 20, group: 'g517'},
            {type: 'y', x: 783, y: 539, w: 30, h: 20, group: 'g539'},
            {type: 'y', x: 749, y: 539, w: 30, h: 20, group: 'g539'},
            {type: 'y', x: 783, y: 561, w: 30, h: 20, group: 'g561'},
            {type: 'y', x: 749, y: 561, w: 30, h: 20, group: 'g561'},
            {type: 'y', x: 783, y: 592, w: 30, h: 20, group: 'g592'},
            {type: 'y', x: 749, y: 592, w: 30, h: 20, group: 'g592'},
            {type: 'y', x: 783, y: 656, w: 30, h: 20, group: 'g656'},
            {type: 'y', x: 749, y: 656, w: 30, h: 20, group: 'g656'},
            {type: 'y', x: 783, y: 687, w: 30, h: 20, group: 'g687'},
            {type: 'y', x: 749, y: 687, w: 30, h: 20, group: 'g687'},
            {type: 'y', x: 783, y: 719, w: 30, h: 20, group: 'g719'},
            {type: 'y', x: 749, y: 719, w: 30, h: 20, group: 'g719'},
            {type: 'y', x: 783, y: 751, w: 30, h: 20, group: 'g751'},
            {type: 'y', x: 749, y: 751, w: 30, h: 20, group: 'g751'},
            {type: 'y', x: 783, y: 773, w: 30, h: 20, group: 'g773'},
            {type: 'y', x: 749, y: 773, w: 30, h: 20, group: 'g773'},
            {type: 'y', x: 783, y: 817, w: 30, h: 20, group: 'g817'},
            {type: 'y', x: 749, y: 817, w: 30, h: 20, group: 'g817'},
            {type: 'y', x: 783, y: 839, w: 30, h: 20, group: 'g839'},
            {type: 'y', x: 749, y: 839, w: 30, h: 20, group: 'g839'},
            {type: 'y', x: 783, y: 872, w: 30, h: 20, group: 'g872'},
            {type: 'y', x: 749, y: 872, w: 30, h: 20, group: 'g872'},
            {type: 'y', x: 783, y: 902, w: 30, h: 20, group: 'g902'},
            {type: 'y', x: 749, y: 902, w: 30, h: 20, group: 'g902'},
            {type: 'y', x: 783, y: 945, w: 30, h: 20, group: 'g945'},
            {type: 'y', x: 749, y: 945, w: 30, h: 20, group: 'g945'},
            {type: 'y', x: 783, y: 966, w: 30, h: 20, group: 'g966'},
            {type: 'y', x: 749, y: 966, w: 30, h: 20, group: 'g966'},
            {type: 'y', x: 783, y: 989, w: 30, h: 20, group: 'g989'},
            {type: 'y', x: 749, y: 989, w: 30, h: 20, group: 'g989'},
            {type: 'y', x: 783, y: 1011, w: 30, h: 20, group: 'g1011'},
            {type: 'y', x: 749, y: 1011, w: 30, h: 20, group: 'g1011'},
            {type: 'y', x: 783, y: 1033, w: 30, h: 20, group: 'g1033'},
            {type: 'y', x: 749, y: 1033, w: 30, h: 20, group: 'g1033'},
            {type: 'y', x: 783, y: 1064, w: 30, h: 20, group: 'g1064'},
            {type: 'y', x: 749, y: 1064, w: 30, h: 20, group: 'g1064'},
            {type: 'y', x: 783, y: 1096, w: 30, h: 20, group: 'g1096'},
            {type: 'y', x: 749, y: 1096, w: 30, h: 20, group: 'g1096'},
            {type: 'y', x: 783, y: 1118, w: 30, h: 20, group: 'g1118'},
            {type: 'y', x: 749, y: 1118, w: 30, h: 20, group: 'g1118'},
            {type: 'y', x: 783, y: 1140, w: 30, h: 20, group: 'g1140'},
            {type: 'y', x: 749, y: 1140, w: 30, h: 20, group: 'g1140'},
            {type: 't', x: 637, y: 1190, w: 507, h: 70, readonly: true, default: props.user.name},
            {type: 'i', x: 262, y: 1172, w: 300, h: 79, readonly: true, default: props.user.signature},
            {type: 't', x: 637, y: 1290, w: 507, h: 70, readonly: true, default: props.delegate.name},
            {type: 'i', x: 262, y: 1272, w: 300, h: 79, readonly: true, default: props.delegate.signature},
        ]
    },
    {
        text: 'صحيفة قياس للشبكة الهوائية',
        image: measurementsSheetForOHNetwork,
        fields: [
            {type: 't', x: 979, y: 180, w: 125, h: 20, default: props.dep},
            {type: 't', x: 556, y: 180, w: 230, h: 20, default: props.div},
            {type: 't', x: 374, y: 172, w: 107, h: 20, default: props.district},
            {type: 't', x: 79, y: 186, w: 178, h: 20, default: props.number},
            {type: 't', x: 627, y: 273, w: 83, h: 24},
            {type: 't', x: 77, y: 273, w: 69, h: 24},
            {type: 't', x: 627, y: 301, w: 83, h: 48},
            {type: 't', x: 77, y: 301, w: 69, h: 48},
            {type: 't', x: 627, y: 352, w: 83, h: 25},
            {type: 't', x: 77, y: 352, w: 69, h: 25},
            {type: 't', x: 627, y: 379, w: 83, h: 25},
            {type: 't', x: 77, y: 379, w: 69, h: 25},
            {type: 't', x: 627, y: 407, w: 83, h: 33},
            {type: 't', x: 77, y: 407, w: 69, h: 33},
            {type: 't', x: 627, y: 443, w: 83, h: 31},
            {type: 't', x: 77, y: 443, w: 69, h: 31},
            {type: 't', x: 627, y: 477, w: 83, h: 54},
            {type: 't', x: 77, y: 477, w: 69, h: 54},
            {type: 't', x: 627, y: 533, w: 83, h: 56},
            {type: 't', x: 77, y: 533, w: 69, h: 56},
            {type: 't', x: 627, y: 592, w: 83, h: 56},
            {type: 't', x: 77, y: 592, w: 69, h: 56},
            {type: 't', x: 627, y: 650, w: 83, h: 56},
            {type: 't', x: 77, y: 650, w: 69, h: 56},
            {type: 't', x: 627, y: 708, w: 83, h: 55},
            {type: 't', x: 77, y: 708, w: 69, h: 55},
            {type: 't', x: 627, y: 765, w: 83, h: 45},
            {type: 't', x: 77, y: 765, w: 69, h: 45},
            {type: 't', x: 627, y: 812, w: 83, h: 56},
            {type: 't', x: 77, y: 812, w: 69, h: 56},
            {type: 't', x: 627, y: 870, w: 83, h: 56},
            {type: 't', x: 77, y: 870, w: 69, h: 56},
            {type: 't', x: 627, y: 930, w: 83, h: 61},
            {type: 't', x: 77, y: 930, w: 69, h: 61},
            {type: 't', x: 627, y: 993, w: 83, h: 58},
            {type: 't', x: 77, y: 993, w: 69, h: 58},
            {type: 't', x: 627, y: 1054, w: 83, h: 54},
            {type: 't', x: 77, y: 1054, w: 69, h: 54},
            {type: 't', x: 627, y: 1112, w: 83, h: 24},
            {type: 't', x: 77, y: 1112, w: 69, h: 24},
            {type: 't', x: 627, y: 1139, w: 83, h: 24},
            {type: 't', x: 77, y: 1139, w: 69, h: 24},
            {type: 't', x: 627, y: 1166, w: 83, h: 36},
            {type: 't', x: 77, y: 1166, w: 69, h: 36},
            {type: 't', x: 627, y: 1206, w: 83, h: 24},
            {type: 't', x: 77, y: 1206, w: 69, h: 24},
            {type: 't', x: 627, y: 1234, w: 83, h: 24},
            {type: 't', x: 77, y: 1234, w: 69, h: 24},
            {type: 'ta', x: 77, y: 1295, w: 1127, h: 31},
            {type: 't', x: 425, y: 1359, w: 666, h: 20, default: props.user.name, readonly: true},
            {type: 'i', x: 170, y: 1328, w: 200, h: 52, default: props.user.signature, readonly: true},
            {type: 't', x: 425, y: 1405, w: 423, h: 20, default: props.delegate.name, readonly: true},
            {type: 'i', x: 170, y: 1379, w: 200, h: 52, default: props.delegate.signature, readonly: true},
        ]
    },
    {
        text: 'تقرير ملخص تنفيذ الخط الهوائي',
        image: overheadLineAsBuiltReportSummary,
        fields: [
            {type: 't', x: 1025, y: 181, w: 50, h: 35, default: props.dep, align: 'center'},
            {type: 't', x: 125, y: 181, w: 268, h: 35, default: props.div, align: 'center'},
            {type: 't', x: 963, y: 333, w: 217, h: 31, default: props.number, align: 'center'},
            {type: 't', x: 735, y: 333, w: 224, h: 31, default: props.district, align: 'center'},
            {type: 't', x: 455, y: 333, w: 276, h: 31, default: props.contractor, align: 'center'},
            {type: 't', x: 354, y: 421, w: 98, h: 50, align: 'center'},
            {type: 't', x: 267, y: 421, w: 85, h: 50, align: 'center'},
            {type: 't', x: 180, y: 421, w: 85, h: 50, align: 'center'},
            {type: 't', x: 79, y: 421, w: 99, h: 50, align: 'center'},
            {type: 't', x: 354, y: 474, w: 98, h: 50, align: 'center'},
            {type: 't', x: 267, y: 474, w: 85, h: 50, align: 'center'},
            {type: 't', x: 180, y: 474, w: 85, h: 50, align: 'center'},
            {type: 't', x: 79, y: 474, w: 99, h: 50, align: 'center'},
            {type: 't', x: 354, y: 528, w: 98, h: 50, align: 'center'},
            {type: 't', x: 267, y: 528, w: 85, h: 50, align: 'center'},
            {type: 't', x: 180, y: 528, w: 85, h: 50, align: 'center'},
            {type: 't', x: 79, y: 528, w: 99, h: 50, align: 'center'},
            {type: 't', x: 354, y: 580, w: 98, h: 50, align: 'center'},
            {type: 't', x: 267, y: 580, w: 85, h: 50, align: 'center'},
            {type: 't', x: 180, y: 580, w: 85, h: 50, align: 'center'},
            {type: 't', x: 79, y: 580, w: 99, h: 50, align: 'center'},
            {type: 't', x: 354, y: 632, w: 98, h: 50, align: 'center'},
            {type: 't', x: 267, y: 632, w: 85, h: 50, align: 'center'},
            {type: 't', x: 180, y: 632, w: 85, h: 50, align: 'center'},
            {type: 't', x: 79, y: 632, w: 99, h: 50, align: 'center'},
            {type: 't', x: 354, y: 685, w: 98, h: 50, align: 'center'},
            {type: 't', x: 267, y: 685, w: 85, h: 50, align: 'center'},
            {type: 't', x: 180, y: 685, w: 85, h: 50, align: 'center'},
            {type: 't', x: 79, y: 685, w: 99, h: 50, align: 'center'},
            {type: 't', x: 354, y: 738, w: 98, h: 50, align: 'center'},
            {type: 't', x: 267, y: 738, w: 85, h: 50, align: 'center'},
            {type: 't', x: 180, y: 738, w: 85, h: 50, align: 'center'},
            {type: 't', x: 79, y: 738, w: 99, h: 50, align: 'center'},
            {type: 't', x: 354, y: 791, w: 98, h: 50, align: 'center'},
            {type: 't', x: 267, y: 791, w: 85, h: 50, align: 'center'},
            {type: 't', x: 180, y: 791, w: 85, h: 50, align: 'center'},
            {type: 't', x: 79, y: 791, w: 99, h: 50, align: 'center'},
            {type: 't', x: 354, y: 851, w: 98, h: 69, align: 'center'},
            {type: 't', x: 267, y: 851, w: 85, h: 69, align: 'center'},
            {type: 't', x: 180, y: 851, w: 85, h: 69, align: 'center'},
            {type: 't', x: 79, y: 851, w: 99, h: 69, align: 'center'},
            {type: 't', x: 354, y: 923, w: 98, h: 84, align: 'center'},
            {type: 't', x: 267, y: 923, w: 85, h: 84, align: 'center'},
            {type: 't', x: 180, y: 923, w: 85, h: 84, align: 'center'},
            {type: 't', x: 79, y: 923, w: 99, h: 84, align: 'center'},
            {type: 't', x: 354, y: 1010, w: 98, h: 69, align: 'center'},
            {type: 't', x: 267, y: 1010, w: 85, h: 69, align: 'center'},
            {type: 't', x: 180, y: 1010, w: 85, h: 69, align: 'center'},
            {type: 't', x: 79, y: 1010, w: 99, h: 69, align: 'center'},
            {type: 't', x: 354, y: 1083, w: 98, h: 40, align: 'center'},
            {type: 't', x: 267, y: 1083, w: 85, h: 40, align: 'center'},
            {type: 't', x: 180, y: 1083, w: 85, h: 40, align: 'center'},
            {type: 't', x: 79, y: 1083, w: 99, h: 40, align: 'center'},
            {type: 't', x: 354, y: 1125, w: 98, h: 41, align: 'center'},
            {type: 't', x: 267, y: 1125, w: 85, h: 41, align: 'center'},
            {type: 't', x: 180, y: 1125, w: 85, h: 41, align: 'center'},
            {type: 't', x: 79, y: 1125, w: 99, h: 41, align: 'center'},
            {type: 't', x: 354, y: 1169, w: 98, h: 41, align: 'center'},
            {type: 't', x: 267, y: 1169, w: 85, h: 41, align: 'center'},
            {type: 't', x: 180, y: 1169, w: 85, h: 41, align: 'center'},
            {type: 't', x: 79, y: 1169, w: 99, h: 41, align: 'center'},
            {type: 'ta', x: 80, y: 1234, w: 1095, h: 23, align: 'center'},
            {type: 't', x: 407, y: 1282, w: 660, h: 21, default: props.user.name, readonly: true},
            {type: 'i', x: 145, y: 1253, w: 200, h: 52, default: props.user.signature, readonly: true},
            {type: 't', x: 407, y: 1325, w: 416, h: 21, default: props.delegate.name, readonly: true},
            {type: 'i', x: 145, y: 1301, w: 200, h: 52, default: props.delegate.signature, readonly: true},
        ]
    },
    {
        text: 'عداد بمحولات جهد متوسط',
        image: mvMeterInstallation,
        fields: [
            {type: 't', x: 689, y: 210, w: 311, h: 22, default: props.dep},
            {type: 't', x: 108, y: 210, w: 478, h: 22, default: props.div},
            {type: 't', x: 744, y: 243, w: 397, h: 22, default: props.district},
            {type: 't', x: 752, y: 276, w: 389, h: 22, default: props.contractor},
            {type: 't', x: 250, y: 261, w: 208, h: 22, default: props.number, align: 'center'},
            {type: 'y', x: 687, y: 419, w: 56, h: 23, group: 'g419'},
            {type: 'y', x: 623, y: 419, w: 61, h: 23, group: 'g419'},
            {type: 'y', x: 687, y: 474, w: 56, h: 23, group: 'g474'},
            {type: 'y', x: 623, y: 474, w: 61, h: 23, group: 'g474'},
            {type: 'y', x: 687, y: 518, w: 56, h: 23, group: 'g518'},
            {type: 'y', x: 623, y: 518, w: 61, h: 23, group: 'g518'},
            {type: 'y', x: 687, y: 563, w: 56, h: 23, group: 'g563'},
            {type: 'y', x: 623, y: 563, w: 61, h: 23, group: 'g563'},
            {type: 'y', x: 687, y: 609, w: 56, h: 23, group: 'g609'},
            {type: 'y', x: 623, y: 609, w: 61, h: 23, group: 'g609'},
            {type: 'y', x: 687, y: 652, w: 56, h: 23, group: 'g652'},
            {type: 'y', x: 623, y: 652, w: 61, h: 23, group: 'g652'},
            {type: 'y', x: 687, y: 697, w: 56, h: 23, group: 'g697'},
            {type: 'y', x: 623, y: 697, w: 61, h: 23, group: 'g697'},
            {type: 'y', x: 687, y: 742, w: 56, h: 23, group: 'g742'},
            {type: 'y', x: 623, y: 742, w: 61, h: 23, group: 'g742'},
            {type: 'y', x: 687, y: 797, w: 56, h: 23, group: 'g797'},
            {type: 'y', x: 623, y: 797, w: 61, h: 23, group: 'g797'},
            {type: 'y', x: 687, y: 852, w: 56, h: 23, group: 'g852'},
            {type: 'y', x: 623, y: 852, w: 61, h: 23, group: 'g852'},
            {type: 'y', x: 687, y: 887, w: 56, h: 23, group: 'g887'},
            {type: 'y', x: 623, y: 887, w: 61, h: 23, group: 'g887'},
            {type: 'y', x: 687, y: 921, w: 56, h: 23, group: 'g921'},
            {type: 'y', x: 623, y: 921, w: 61, h: 23, group: 'g921'},
            {type: 'c', x: 783, y: 1036, w: 25, h: 25, group: 'g1036'},
            {type: 'c', x: 690, y: 1036, w: 25, h: 25, group: 'g1036'},
            {type: 't', x: 108, y: 1091, w: 912, h: 21, default: props.user.name, readonly: true},
            {type: 'i', x: 829, y: 1115, w: 250, h: 65, default: props.user.signature, readonly: true},
            {type: 't', x: 108, y: 1185, w: 643, h: 21, default: props.delegate.name, readonly: true},
            {type: 'i', x: 829, y: 1213, w: 250, h: 65, default: props.delegate.signature, readonly: true},
        ]
    },
    {
        text: 'نموذج متابعة مخالفات الموقع',
        image: siteInfractionForm,
        fields: [
            {type: 't', x: 660, y: 191, w: 260, h: 24, default: props.dep},
            {type: 't', x: 149, y: 191, w: 335, h: 24, default: props.div},
            {type: 't', x: 660, y: 220, w: 157, h: 24, default: props.contractor},
            {type: 't', x: 148, y: 220, w: 246, h: 24, default: props.number},
            {type: 'y', x: 653, y: 334, w: 69, h: 45, group: 'g334'},
            {type: 'y', x: 597, y: 334, w: 52, h: 45, group: 'g334'},
            {type: 'y', x: 653, y: 382, w: 69, h: 45, group: 'g382'},
            {type: 'y', x: 597, y: 382, w: 52, h: 45, group: 'g382'},
            {type: 'y', x: 653, y: 465, w: 69, h: 45, group: 'g465'},
            {type: 'y', x: 597, y: 465, w: 52, h: 45, group: 'g465'},
            {type: 'y', x: 653, y: 548, w: 69, h: 45, group: 'g548'},
            {type: 'y', x: 597, y: 548, w: 52, h: 45, group: 'g548'},
            {type: 'y', x: 653, y: 606, w: 69, h: 45, group: 'g606'},
            {type: 'y', x: 597, y: 606, w: 52, h: 45, group: 'g606'},
            {type: 'y', x: 653, y: 700, w: 69, h: 45, group: 'g700'},
            {type: 'y', x: 597, y: 700, w: 52, h: 45, group: 'g700'},
            {type: 'y', x: 653, y: 808, w: 69, h: 45, group: 'g808'},
            {type: 'y', x: 597, y: 808, w: 52, h: 45, group: 'g808'},
            {type: 'y', x: 653, y: 889, w: 69, h: 45, group: 'g889'},
            {type: 'y', x: 597, y: 889, w: 52, h: 45, group: 'g889'},
            {type: 'y', x: 653, y: 960, w: 69, h: 45, group: 'g960'},
            {type: 'y', x: 597, y: 960, w: 52, h: 45, group: 'g960'},
            {type: 'y', x: 653, y: 1024, w: 69, h: 45, group: 'g1024'},
            {type: 'y', x: 597, y: 1024, w: 52, h: 45, group: 'g1024'},
            {type: 'y', x: 653, y: 1082, w: 69, h: 45, group: 'g1082'},
            {type: 'y', x: 597, y: 1082, w: 52, h: 45, group: 'g1082'},
            {type: 'y', x: 653, y: 1138, w: 69, h: 45, group: 'g1138'},
            {type: 'y', x: 597, y: 1138, w: 52, h: 45, group: 'g1138'},
            {type: 'y', x: 653, y: 1197, w: 69, h: 45, group: 'g1197'},
            {type: 'y', x: 597, y: 1197, w: 52, h: 45, group: 'g1197'},
            {type: 't', x: 769, y: 1303, w: 326, h: 24, readonly: true, default: props.user.name},
            {type: 'i', x: 397, y: 1279, w: 200, h: 52, readonly: true, default: props.user.signature},
            {type: 't', x: 769, y: 1360, w: 326, h: 24, readonly: true, default: props.delegate.name},
            {type: 'i', x: 397, y: 1338, w: 200, h: 52, readonly: true, default: props.delegate.signature},
        ]
    },
    {
        text: 'محضر اثبات حالة',
        image: recordOfFacts,
        fields: [
            {type: 't', x: 968, y: 332, w: 83, h: 62, align: 'center', fontSize: 10},
            {type: 't', x: 852, y: 332, w: 112, h: 62, default: props.now_date, align: 'center', fontSize: 10},
            {type: 't', x: 707, y: 332, w: 141, h: 62, default: props.number, align: 'center', fontSize: 10},
            {type: 't', x: 635, y: 332, w: 68, h: 62, align: 'center', fontSize: 10},
            {type: 't', x: 475, y: 332, w: 156, h: 62, align: 'center', fontSize: 10},
            {type: 't', x: 330, y: 332, w: 142, h: 62, default: props.contractor, align: 'center', fontSize: 10},
            {type: 't', x: 187, y: 332, w: 140, h: 62, default: 'الزامل', align: 'center', fontSize: 10},
            {type: 'ta', x: 193, y: 474, w: 850, h: 138},
            {type: 'ta', x: 193, y: 654, w: 850, h: 149},
            {type: 'ta', x: 193, y: 920, w: 860, h: 87},
            {type: 't', x: 193, y: 1174, w: 360, h: 23, readonly: true, default: props.user.name},
            {type: 'i', x: 362, y: 1193, w: 150, h: 40, readonly: true, default: props.user.signature},
        ],
    }
]